var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1289_17200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.9992 108C24.1762 108 0 83.8238 0 53.9992C0 24.1762 24.1762 0 53.9992 0C83.8222 0 107.998 24.1762 107.998 53.9992C107.998 83.8222 83.8222 107.998 53.9992 107.998V108Z",
    fill: "#00C07F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5085 81.4871L18.9814 57.9601L27.4461 49.4954L42.5085 64.5577L80.5545 26.5117L89.0192 34.9764L42.5085 81.4871Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1289_17200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 108,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.856ae6809efaebedbf6897ff076306e0.svg";
export { ForwardRef as ReactComponent };